import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { PageContainer } from '../../content/components';
import {
  ColumnBlock,
  ColumnContent,
  ContentSection,
} from '../../layout/components';
import { Button } from '../../pages/components';

const StyledContentSection = styled(ContentSection)`
  padding: ${props => (props.breakpoint !== 'phone' ? 11 : 5)}rem 0;
`;

const StyledFigure = styled.figure`
  width: 20.625rem;
  height: 23.4375rem;
  margin-bottom: 6rem;

  img {
    width: 100%;
    height: 100%;
  }
`;

const FourOFour = props => {
  const { breakpoint } = props;
  return (
    <PageContainer>
      <StyledContentSection breakpoint={breakpoint}>
        <ColumnBlock />
        <ColumnBlock columns={2}>
          <ColumnContent>
            <StyledFigure>
              <img src={`${process.env.PUBLIC_URL}img/404.png`} alt="" />
            </StyledFigure>
            <h2>You're lost...</h2>
            <p>
              It appears you've fallen of the trail and have become lost. The
              page you're looking for doesn't appear to exist. Maybe the address
              is mistyped or you followed an old link.
            </p>
            <p>
              It's probably best to head to our home page and start from there!
            </p>
            <Button to="/">Quick get me back home</Button>
          </ColumnContent>
        </ColumnBlock>
        <ColumnBlock />
      </StyledContentSection>
    </PageContainer>
  );
};

FourOFour.propTypes = {
  breakpoint: PropTypes.string.isRequired,
};

const mapStateToProps = state => {
  const { breakpoint } = state.layout;
  return {
    breakpoint,
  };
};

export default connect(mapStateToProps, null)(FourOFour);



// WEBPACK FOOTER //
// ./src/modules/content/components/FourOFour.js